import React, { useState, useEffect } from "react";
import axios from "axios";
import Haikunator from "haikunator";


const PatientProfile = () => {
  // State to store user information
  const [user, setUser] = useState({
    name: "",
    contact_no: "",
    email: "",
    role: "",
    petname: "",
    is_anonymous: "No", // Default value
  });

  const [isUpdating, setIsUpdating] = useState(false); // Loading state
  const haikunator = new Haikunator(); 
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const canUseAnonymousMode = ["2", "5"].includes(String(user.role));

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("Login_User_Community_All_Data"));
    if (storedUser) {
      setUser({
        name: storedUser.name || "",
        contact_no: storedUser.contact_no || "",
        email: storedUser.email || "",
        role: storedUser.role || "",
        petname: storedUser.petname || "",
        is_anonymous: storedUser.is_anonymous || "No", // Ensure correct initial value
      });
    }
  }, []);

  // Handle changes to editable fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const toggleNameDisplay = () => {
    setUser((prevUser) => {
      const newPetname =
        prevUser.petname || haikunator.haikunate({ delimiter: "-" }); // Generate petname only if it doesn't exist

      return {
        ...prevUser,
        is_anonymous: prevUser.is_anonymous === "Yes" ? "No" : "Yes", 
        petname: prevUser.petname || newPetname, // Ensure petname is generated
      };
    });
  };

  // const toggleNameDisplay = () => {
  //   setUser((prevUser) => {
  //     // Check if petname is already generated
  //     const newPetname =
  //       prevUser.petname && prevUser.is_anonymous === "No"
  //         ? prevUser.petname // Keep the already generated petname
  //         : haikunator.haikunate({ delimiter: "-" }); // Generate a new random petname only if not already set
  
  //     return {
  //       ...prevUser,
  //       is_anonymous: prevUser.is_anonymous === "Yes" ? "No" : "Yes", // Toggle between "Yes" and "No"
  //       petname: prevUser.is_anonymous === "No" ? newPetname : prevUser.petname, // Use the same petname if already generated
  //     };
  //   });
  // };


  // const toggleNameDisplay = () => {
  //   setUser((prevUser) => {
  //     // Generate a pet name if switching to "Anonymous"
  //     const newPetname =
  //       prevUser.is_anonymous === "No"
  //         ? haikunator.haikunate({ delimiter: "-" }) // Generate a random name
  //         : prevUser.petname;

  //     return {
  //       ...prevUser,
  //       is_anonymous: prevUser.is_anonymous === "Yes" ? "No" : "Yes", // Toggle between "Yes" and "No"
  //       petname: prevUser.is_anonymous === "No" ? newPetname : prevUser.petname, // Set the petname when switching to Anonymous
  //     };
  //   });
  // };

    const handleSave = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("Login_User_Community_All_Data"));   
        setIsUpdating(true);
        // Prepare updated data
        const updatedData = {

          name: user.name,
          contact_no: user.contact_no,
          email: user.email,
          petname: user.petname,
          is_anonymous: user.is_anonymous, // Keep the toggled value
        };

      // Send the update request to the backend
      await axios.put(`${API_BASE_URL}/api/users/${storedUser.id}/update`, updatedData);

      // Fetch the latest user data from the backend
      const response = await axios.get(`${API_BASE_URL}/api/getUserDetailsById/${storedUser.id}`);
      const updatedUserData = response.data;

      // Update the React state and localStorage with the latest data
      setUser(updatedUserData);
      localStorage.setItem("Login_User_Community_All_Data", JSON.stringify(updatedUserData));

      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  // const handleSave = async () => {
  //   try {
  //     const storedUser = JSON.parse(localStorage.getItem("Login_User_Community_All_Data"));   
  //     setIsUpdating(true);
  //     // Prepare updated data
  //     const updatedData = {

  //       name: user.name,
  //       contact_no: user.contact_no,
  //       email: user.email,
  //       petname: user.petname,
  //       is_anonymous: user.is_anonymous, // Keep the toggled value
  //     };

  //     // Send the update request to the backend     
  //     const response = await axios.put(`http://127.0.0.1:8000/api/users/${storedUser.id}/update`, updatedData);
  //     // Update localStorage with the new user data
  //     const updatedUser = {
  //       ...user,
  //     };
  //     localStorage.setItem("Login_User_Community_All_Data", JSON.stringify(updatedUser));
  //     alert("Profile updated successfully!");
  //   } catch (error) {
  //     console.error("Error updating profile:", error);
  //     alert("Failed to update profile. Please try again.");
  //   } finally {
  //     setIsUpdating(false);
  //   }
  // };

  //console.log("user====",user);
  return (
    <div style={{ maxWidth: "100%", margin: "auto", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
      <h2>Patient Profile</h2>
      <div>
        <label style={{ display: "block", marginBottom: "8px" }}>Name:</label>
        <input
          type="text"
          name="name"
          //value={user.displayNameAs === "Original" ? user.name : "Anonymous"}
          value={user.name}
          onChange={handleInputChange}
          //disabled={user.displayNameAs === "Anonymous"} // Disable input when name is "Anonymous"
          style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
        />
      </div>
      <div>
        <label style={{ display: "block", marginBottom: "8px" }}>Contact Number:</label>
        <input
          type="text"
          name="contact_no"
          value={user.contact_no}
          onChange={handleInputChange}
          style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
        />
      </div>
      <div>
        <label style={{ display: "block", marginBottom: "8px" }}>Email:</label>
        <input
          type="text"
          name="email"
          value={user.email}
          onChange={handleInputChange}
          disabled
          style={{ width: "100%", padding: "8px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "5px" }}
        />
      </div>
      <div>
        <label style={{ display: "block", marginBottom: "8px" }}>Role:</label>
        <input
          type="text"
          value={
            user?.role === "1"
              ? "Super Admin"
              : user?.role === "2"
              ? "Patient"
              : user?.role === "3"
              ? "Provider"
              : user?.role === "4"
              ? "Vendor"
              : user?.role === "5"
              ? "Civilian"
              : user?.role === "6"
              ? "Admin"
              : "Unknown"
          }
          disabled
          style={{
            width: "100%",
            padding: "8px",
            marginBottom: "15px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: "#f9f9f9",
          }}
        />
      </div>
      {canUseAnonymousMode && (
        <>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
              <input
                type="checkbox"
                checked={user.is_anonymous === "Yes"}
                onChange={toggleNameDisplay}
              />
              Post Anonymously
            </label>
          </div>

          <div>
            <label style={{ display: "block", marginBottom: "8px" }}>Display Name (shown when anonymous):</label>
            <input
              type="text"
              name="petname"
              value={user.petname}
              onChange={handleInputChange}
              style={{
                width: "100%",
                padding: "8px",
                marginBottom: "15px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>
        </>
      )}
      <button
        onClick={handleSave}
        style={{
          padding: "10px 20px",
          backgroundColor: isUpdating ? "#ccc" : "#28a745",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: isUpdating ? "not-allowed" : "pointer",
        }}
        disabled={isUpdating}
      >
        {isUpdating ? "Saving..." : "Save"}
      </button>
    </div>
  );
};

export default PatientProfile;
